import React, { createContext, useContext, useState, useCallback } from "react";

const MobileSidebarContext = createContext(null);

export function MobileSidebarProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((p) => !p), []);

  return (
    <MobileSidebarContext.Provider value={{ isOpen, setIsOpen, open, close, toggle }}>
      {children}
    </MobileSidebarContext.Provider>
  );
}

export function useMobileSidebar() {
  const ctx = useContext(MobileSidebarContext);
  if (!ctx) {
    // Return a no-op fallback so components work outside the provider
    return { isOpen: false, setIsOpen: () => {}, open: () => {}, close: () => {}, toggle: () => {} };
  }
  return ctx;
}
